import { ActivityLogFilterInterface } from '@/types/ActivityLog';
import { useRequestCancel } from '@/composables/useRequestCancel';
import { REQUEST } from '@/enum';
import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';

export default class ActivityLogService {
  static requestCancel = useRequestCancel();

  static queryFilter(payload: ActivityLogFilterInterface) {
    let filter = '';

    if (payload) {
      filter = `?${Object.keys(payload)
        .filter((item) => payload[item as keyof ActivityLogFilterInterface] !== '')
        .map((item) => `${item}=${payload[item as keyof ActivityLogFilterInterface]}`)
        .join('&')}`;
    }

    return filter;
  }

  static getLogs(person: number, payload: ActivityLogFilterInterface, page: number): ApiPromise {
    return HTTP.get(`person/${person}/logs${this.queryFilter(payload)}&page=${page}`, {
      ...this.requestCancel.requestSaverSetCancellation(REQUEST.LOGS),
    });
  }
}
